import React from 'react'
import { SomethingWentWrong } from '../SomethingWentWrong'

export const TheWestSomethingWentWrong = () => (
    <SomethingWentWrong attribution />
)
